<template>
    <div :style="{'height' : theTableHeight +'px' }">
        <div name="simple-row-btn" class="simple-row" v-if="checkActionPerm('allocation_of_cargo') && !goodsOrderCancelled && manualAllocFlag && goodsOrder != null && !goodsOrder.shipAborted">
            <div class="left"><!--&& !contractIdIsNull-->
                <el-button class="el-search-btn" type="primary" @click="goSwbOrderGoodsAllocItemSaveVue()">
                    <span>配货</span>
                </el-button>
            </div>
        </div>
        <template v-if="goodsAllocDtoList.length > 0" v-for="goodsAllocDto in goodsAllocDtoList">
            <div class="simple-form flex col-4 label">
                <div class="form-group center">
                    <div class="form-label">
                        <label>配货标题</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsAllocDto.title || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务单元</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsAllocDto.buyerBizUnitName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsAllocDto.buyerShopName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>联系人</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsAllocDto.buyerRecvContractName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>联系电话</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsAllocDto.buyerRecvContactTel || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收货地址</label>
                    </div>
                    <div class="form-value">
                        <span>{{goodsAllocDto.buyerRecvAddr || '无'}}</span>
                    </div>
                </div>
            </div>
            <div name="simple-row-btns" class="simple-row" v-if="(checkActionPerm('sendAllocForm') && goodsAllocDto.state == 0) || (checkActionPerm('deleteAllocForm') && goodsAllocDto.state == 0) || (checkActionPerm('returnAllocForm') && goodsAllocDto.state == 1)">
                <div class="left">
                    <!--<a v-if="checkActionPerm('sendAllocForm') && goodsAllocDto.state == 0" class="swb-btn swb-btn-small" @click="sendAllocForm(goodsAllocDto);">发送</a>-->
                    <!--<a v-if="checkActionPerm('deleteAllocForm') && goodsAllocDto.state == 0" class="swb-btn swb-btn-small" @click="deleteAllocForm(goodsAllocDto);">删除</a>-->
                    <!--<a v-if="checkActionPerm('returnAllocForm') && goodsAllocDto.state == 1" class="swb-btn swb-btn-small" @click="doReturnAllocForm(goodsAllocDto);">撤回</a>-->
                </div>
            </div>
            <div class="table-layout" name="result_table" :tableHeight="tableHeight">
                <el-table :data="goodsAllocDto.itemList" border style="width: 100%">
                    <el-table-column align="left" prop="title" label="名称"></el-table-column>
                    <!--<el-table-column align="left" prop="model" label="型号" width="120"></el-table-column>-->
                    <!--<el-table-column align="left" prop="fixedSpec" label="规格" width="120"></el-table-column>-->
                    <el-table-column align="left" prop="catName" label="分类" width="150"></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌" width="120"></el-table-column>
                    <el-table-column align="center" prop="asmblAccFlag" label="组装件" width="80">
                        <template slot-scope="scope">
                            <span v-if="scope.row.asmblAccFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="关联定义">
                        <template slot-scope="rows">
                            <div class="inline-block" v-if="rows.row.assetDefId != null">已关联</div>
                            <div class="inline-block" v-else>未关联</div>
                        </template>
                    </el-table-column>
                    <!--<el-table-column align="left" width="120px" prop="devcName" label="定义全名称">-->
                    <!--<template slot-scope="rows">-->
                    <!--<div class="inline-block" v-if="rows.row.assetDefId != null">{{rows.row.devcName || ''}}</div>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column align="right" prop="price" label="含税价(元)" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.price || 0.00}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="taxRate" label="税率(%)" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.taxRate || 0.00}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.ntxPrice || 0.00}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="quantity" label="配货数量" width="80"></el-table-column>
                    <el-table-column align="right" prop="shipQuantity" label="发货数量" width="100">
                        <template slot-scope="scope">
                            <span class="font-green" v-if="scope.row.shipQuantity != null">{{scope.row.shipQuantity}}</span>
                            <span class="font-green" v-else>0</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="recvQuantity" label="收货数量" width="100">
                        <template slot-scope="scope">
                            <span class="font-green" v-if="scope.row.recvQuantity != null">{{scope.row.recvQuantity}}</span>
                            <span class="font-green" v-else>0</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column align="left" prop="id" label="操作" width="80">-->
                    <!--<template slot-scope="rows">-->
                    <!--<a class="swb-btn-link" v-if="checkActionPerm('cut_down')" @click="reduceAllocItem(rows.row, goodsAllocDto)">调减</a>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>
            </div>
        </template>
        <!--<div v-if="goodsAllocDtoList.length <= 0 && onloading">-->
        <!--<div class="no-data">-->
        <!--<i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>-->
        <!--<span class="">暂无数据 . . .</span>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>

    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { RouteLayerMgr, showRouteLayer } from '../ctrl/RouteLayer'

    import goodsOrderApi from '../../api/goodsOrder'

    import SwbOrderGoodsAllocItemSave from './OrderGoodsAllocItemSave';
    Vue.regist(SwbOrderGoodsAllocItemSave);

    import SwbOrderGoodsAllocDetails from './OrderGoodsAllocDetails';
    Vue.regist(SwbOrderGoodsAllocDetails);

    import SwbOrderGoodsAllocItemReduce from './OrderGoodsAllocItemReduce';
    Vue.regist(SwbOrderGoodsAllocItemReduce);

    export default {
        name: 'swb-order-goods-alloc-item-list',
        desc: '配货信息列表',
        props: ['goodsOrderId', 'manualAllocFlag', 'selfPath'],
        data: function () {
            return {
                goodsAllocDtoList: [],
                goodsOrder: null,
                contractIdIsNull: false,
                goodsOrderCancelled: false,
                isProxied: false,
                msgBoxDlg: null,
                onloading: false
            }
        },
        created: function () {
            this.getGoodsOrderInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
                RouteLayerMgr.resizeLayers();
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.simple-form', '[name="simple-row-btn"]', '[name="simple-row-btns"]'));
            domSizeWatcher.start(500);
            //
        },
        methods: {
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(this.selfPath, action, targetPostId);
            },
            goSwbOrderGoodsAllocItemSaveVue: function () {   // 配货页面
                let self = this;
                showRouteLayer({
                    title: '去配货',
                    data: {
                        //
                        orderId: self.goodsOrderId,
                        manualAllocFlag: self.manualAllocFlag,
                        goodsOrderCancelled: self.goodsOrderCancelled
                    },
                    template: '<swb-order-goods-alloc-item-save ref="theCtrl" :orderId="orderId" :manualAllocFlag="manualAllocFlag" :goodsOrderCancelled="goodsOrderCancelled"></swb-order-goods-alloc-item-save>',
                    // 下面的扩展按钮及处理函数（this可正常使用，不提供或length=0，则不显示footer栏）
                    footerBtns: [
                        {
                            name: 'ok',
                            text: '确 定',
                            handler: function (routerLayer) {
                                let selfX = this;
                                let theCtrl = this.$refs['theCtrl'];
                                let resultInfo = theCtrl.getDlgResult();
                                if (resultInfo.type == 'info') {
                                    let orderGoodsAllocDto = resultInfo.data;
                                    //
                                    let theLoad = MsgBox.loading();
                                    goodsOrderApi.saveOrderGoodsAllocItems(orderGoodsAllocDto, function (result) {
                                        theLoad.hide();
                                        if(result.type === "info") {
                                            MsgBox.success("配货成功");
                                            // 主动关闭（this == routerLayer）
                                            selfX.close();
                                            //
                                            self.getGoodsOrderInfo();
                                        } else {
                                            MsgBox.warning(result.message);
                                        }
                                    });
                                } else {
                                    MsgBox.warning(resultInfo.message);
                                }
                                return false;
                            }
                        },
                        {
                            name: 'cancel',
                            text: '取 消'
                        }
                    ]
                });
            },
            // 配货信息
            getGoodsOrderInfo: function () {
                let self = this;
                let orderId = self.goodsOrderId;
                let postData = {};
                postData.id = orderId;
                postData.includeSubItems = false;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getGoodsOrderInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let goodsOrder = result.data;
                        // console.log("goodsOrder===" + JSON.encode(goodsOrder));
                        if(goodsOrder.contractId == null) {
                            self.contractIdIsNull = true;
                        }
                        self.isProxied = goodsOrder.proxied;
                        self.goodsOrderCancelled = goodsOrder.cancelled;
                        self.goodsOrder = goodsOrder;
                        self.getGoodsAllocDtoList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 配货列表
            getGoodsAllocDtoList: function () {
                let self = this;

                let postData = {};
                let filterItems = {};
                let sortItemList = [];
                let sortItems = {};
                filterItems.orderId = self.goodsOrderId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocFromListByOrderId(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let goodsAllocDtoList = result.data || [];
                        for(let i = 0; i < goodsAllocDtoList.length; i++) {
                            let goodsAllocDto = goodsAllocDtoList[i];
                            let itemList = goodsAllocDto.itemList || [];
                            for(let j = 0; j < itemList.length; j++) {
                                let item = itemList[j];
                                item.devcName = item.title || '' + item.model || '' + item.fixedSpec || '';
                                item.price = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                                item.taxRate = Utils.isNoB(item.taxRate) ? 0.00 : parseFloat(item.taxRate).toFixed(2);
                                item.ntxPrice = Utils.isNoB(item.ntxPrice) ? 0.00 : parseFloat(item.ntxPrice).toFixed(2);
                            }
                            goodsAllocDto.itemList = Utils.merge([], itemList);
                        }
                        self.goodsAllocDtoList = Utils.merge([], goodsAllocDtoList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 发送
            sendAllocForm: function (row) {
                let self = this;
                self.$confirm('确定要发送当前配货单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.formId = row.id;
                    let theLoad = MsgBox.loading();
                    goodsOrderApi.doUpdateOrderGoodsAllocFormState(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('发送成功!');
                            self.getGoodsAllocDtoList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 删除
            deleteAllocForm: function (row) {
                let self = this;
                self.$confirm('确定要删除当前配货单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = row.id;
                    let theLoad = MsgBox.loading();
                    goodsOrderApi.doDeleteOrderGoodsAllocForm(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('删除成功!');
                            self.getGoodsAllocDtoList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 撤回
            doReturnAllocForm: function (row) {
                let self = this;
                self.$confirm('确定要撤回当前配货单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.formId = row.id;
                    let theLoad = MsgBox.loading();
                    goodsOrderApi.doCancelOrderGoodsAllocForm(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('撤回成功!');
                            self.getGoodsAllocDtoList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            //
            openOrderGoodsAllocItemDlg: function (orderId, buyerShopId, buyerShopName) {
                let title = "查看【" + buyerShopName + "】机构配货详情";
                Vue.$showDialog({
                    title: title,
                    width: 1000,
                    height: 500,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-order-goods-alloc-details :orderId="orderId" :buyerShopId="buyerShopId"  ref="swb_order_goods_alloc_details"></swb-order-goods-alloc-details>' +
                    '</div>',
                    data: {
                        orderId: orderId,
                        buyerShopId: buyerShopId
                    },
                    methods: {},
                    okClicked: function () {

                    },
                    lifecycle: {}
                });
            },
            //
//            reduceAllocItem: function (item, goodsAllocDto) {
//                let shipQuantity = item.shipQuantity;
//                let expectExchangeQuantity = item.expectExchangeQuantity;
//                let quantity = item.quantity;
//                let reductionQuantity = quantity - (shipQuantity - expectExchangeQuantity);
//                if(reductionQuantity <= 0) {
//                    MsgBox.warning("没有可调减的数量啦！");
//                    return;
//                }
//                let self = this;
//                Vue.$showDialog({
//                    title: '调减信息',
//                    width: 600,
//                    height: 400,
//                    showCloseBtn: true,
//                    cancleVisible: false,
//                    template: '<div>' +
//                    '<swb-order-goods-alloc-reduce :title="title" :quantity="quantity" :maxQuantity = "maxQuantity" ref="swb_order_goods_alloc_reduce"></swb-order-goods-alloc-reduce>' +
//                    '</div>',
//                    data: {
//                        title: item.title,
//                        quantity: quantity,
//                        maxQuantity: reductionQuantity
//                    },
//                    okClicked: function () {
//                        let result = this.$refs.swb_order_goods_alloc_reduce.getDlgResult() || null;
//                        if(result.type === 'info') {
//                            //
//                            let postData = {};
//                            postData.quantity = result.reduceQuantity;
//                            postData.orderItemId = item.orderItemId;
//                            postData.buyerShopId = goodsAllocDto.buyerShopId;
//                            postData.buyerShopName = goodsAllocDto.buyerShopName;
//                            postData.buyerId = goodsAllocDto.buyerId;
//                            //
//                            let theLoad = MsgBox.loading();
//                            goodsOrderApi.reduceGoodsAllocItemDo(postData, function (result) {
//                                theLoad.hide();
//                                if(result.type === 'info') {
//                                    //
//                                    Toast.show('调减成功！', 2000, 'success');
//                                    self.getGoodsAllocDtoList();
//                                } else {
//                                    MsgBox.warning(result.message);
//                                }
//                            });
//                            return true;
//                        } else {
//                            MsgBox.warning(result.message);
//                            return false;
//                        }
//                    },
//                    methods: {}
//                });
//            },

            // 作废
            invalidAlloc: function (id) {
                let self = this;
                self.$confirm('确定要作废吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsOrderApi.invalidateOrderGoodsAllocItem(id, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            MsgBox.success("成功");
                            self.getGoodsAllocDtoList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }).catch(function () {
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocItemList.vue